import ApplicationComponent from "legacy/ApplicationComponent"
import { getUrlParam } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class TabView extends ApplicationComponent {
  constructor(props) {
    super(props)
    let tabIndex = 0
    const initialTab = this.props.initialTab
    const tabName = getUrlParam("tab")
    if (tabName && this.props.tabs[tabName]) {
      tabIndex = this.tabIndexByName(tabName)
    } else if (initialTab && this.props.tabs[initialTab]) {
      tabIndex = this.tabIndexByName(initialTab)
    }
    this.state = {
      activeTabIndex: tabIndex,
    }

    this.tabClick = this.tabClick.bind(this)
  }

  tabIndexByName(tabName) {
    return Object.keys(this.props.tabs).indexOf(tabName)
  }

  tabClick(activeTabIndex) {
    this.setState({ activeTabIndex })
    if (this.props.pushTabToUrl) {
      window.history.replaceState(
        null,
        document.title,
        "?tab=" + Object.keys(this.props.tabs)[activeTabIndex]
      )
    }
  }

  isActive(index) {
    return this.state.activeTabIndex === index
  }

  tabStyle(index) {
    const styles = { flexBasis: 0 }
    if (this.isActive(index)) {
      styles.borderBottomColor = "transparent"
    }
    return styles
  }

  tabs() {
    return Object.values(this.props.tabs).map((value, index) => {
      return (
        <button
          key={index}
          type="button"
          className={`flex-grow rounded-t border py-3 font-semibold text-gray-900 ${
            this.isActive(index) ? "bg-white" : "bg-gray-200 hover:bg-gray-100"
          }`}
          style={this.tabStyle(index)}
          onClick={() => this.tabClick(index)}
        >
          {value}
        </button>
      )
    })
  }

  render() {
    return (
      <div>
        <div className="flex gap-1">{this.tabs()}</div>
        <div className="card -mt-px rounded-t-none">
          {this.props.children[this.state.activeTabIndex]}
        </div>
      </div>
    )
  }
}

TabView.propTypes = {
  tabs: PropTypes.object.isRequired,
  initialTab: PropTypes.string,
  pushTabToUrl: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
}

TabView.defaultProps = {
  tabs: {},
  children: [],
}

export default TabView
